import AnalyticsData from 'app/modules/data/analytics';
import HideableElement from 'app/ui/hideable-element';
import Form from 'launch/modules/brief-form';
import FormChangeTracker from 'launch/modules/form-change-tracker';
import AutoSaver from 'launch/modules/auto-saver';
import CategoryPackUpsell from 'launch/modules/category-pack-upsell';
import BriefEmailBeforeSignupField from 'launch/modules/brief-email-before-signup-field';
import WebsiteInspiration from 'app/modules/website-inspiration';
import FileUploader from 'app/modules/file-uploader';
import LogoUploader from 'app/modules/logo-uploader';
import LogoType from 'app/modules/logo-type';
import WebsiteTemplate from 'app/modules/website-template';
import Accordion from 'app/ui/accordion';
import 'app/modules/range-slider';
import CreateMultipleChoiceDropdown from 'launch/modules/create-multiple-choice-dropdown';
import DraftPrefillToggle from 'launch/modules/draft-prefill-toggle';

import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import Tooltip from '@99designs/react-components/components/Tooltip';
import Icon from '@99designs/react-components/components/Icon';
import StockUsageExample from 'contest/components/StockUsageExample';

function initStockExampleInfobox(renderNode, { intl, example }) {
    ReactDOM.render(
        <IntlProvider {...intl}>
            <Tooltip tooltipElement={<StockUsageExample {...example} />}>
                <Icon variations={['question-mark-2']} />
            </Tooltip>
        </IntlProvider>,
        renderNode
    );
}

$(function() {
    const stockUsageExampleData = document.getElementById('stock-usage-example-data');
    const stockUsageExampleNode = document.querySelector('[data-stock-usage-tooltip]');

    if (stockUsageExampleData && stockUsageExampleNode) {
        initStockExampleInfobox(
            stockUsageExampleNode,
            JSON.parse(stockUsageExampleData.textContent)
        );
    }

    AnalyticsData.attachTo(document, {
        namespace: 'Launch Brief',
        events: {
            uiBriefEmailBeforeSignupChanged: 'Email Entered',
        },
    });

    Form.attachTo('#briefform');
    FormChangeTracker.attachTo('#briefform');

    AutoSaver.attachTo('#briefform', {
        action: window.app.routes.autoSave,
        step: 'brief',
    });

    $('[data-rangeslider-type]').rangeslider();

    CategoryPackUpsell.attachTo('#briefform');

    BriefEmailBeforeSignupField.attachTo('[data-email-before-signup-field]');

    WebsiteInspiration.attachTo('.js-website-inspiration');

    FileUploader.attachTo('.js-file-uploader', {
        extraDropzones: [$('.js-file-uploader')],
    });

    LogoUploader.attachTo('.js-example-logos', {
        extraDropzones: [$('.js-example-logos')],
        listselector: '.js-uploader-logo-list',
    });

    LogoType.attachTo('.js-logo-type');
    WebsiteTemplate.attachTo('[data-website-templates]');

    Accordion.attachTo('[data-accordion]');

    HideableElement.attachTo('[data-brief-layout-group-website]', {
        showEvent: 'uiBriefCategoryPackSelected:logo-website',
        hideEvent: 'uiBriefCategoryPackDeselected:logo-website',
        stateAttr: 'data-brief-layout-group-website-default-state',
        default: 'html',
    });

    CreateMultipleChoiceDropdown.create('[data-multiple-choice-dropdown]');

    DraftPrefillToggle.attachTo('[data-draft-prefill-toggle]');
});



// WEBPACK FOOTER //
// ./src/web/js/launch/brief.js